import { Image,  Typography} from "antd"
import img from "../Assets/lo.png";
import './index.css'
function AppHeader() {
return(

    <div className="AppHeader">
      <Image
       width={40}
       src={`${img}`}></Image>
       <Typography.Title style={{fontSize:20 , fontWeight:"bold"}}>SUPER ADMIN</Typography.Title>
     
</div>
);
}
export default AppHeader
